<template>
  <div>
    <el-row type="flex" justify="end" class="desc-table-top">
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </el-row>
    <el-row>
      <el-table-wrapper v-loading="isLoading" ref="storageClusterTable" border :data="tableDatas" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" :show-overflow-tooltip="true"
      :pagination="true" :remote="true" :total="tableTotal" :column-default="columnDefault" @condition-change="onChangeTable">
      <template slot-scope="scope" slot="disk-slot">
        <w-rsc-perf-event-progress-bar v-if="!isNil(scope.row['VDSC_STORAGE/USERATE'])" :perfRecords="scope.row" perfKey="VDSC_STORAGE/USERATE" />
        <span v-else>{{ EMPTY_TEXT }}</span>
      </template>
      <template #obj-name-slot="scope">
        <span v-if="scope.row.objName" class="link c-pointer" @click="clickObjName(scope.row)">{{scope.row.objName}}</span>
        <span v-else>-</span>
      </template>
      </el-table-wrapper>
    </el-row>
  </div>
</template>

<script>
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import WRscPerfEventProgressBar from '@/components/progressbar/RscPerfEventProgressBar';
import VmsPerfCommonAPI from '@/api/virtual/performance/common';
import { columnDefault } from '@/constants/table';
import { mapGetters } from 'vuex';
import { isNil, split, isEqual, isEmpty } from 'lodash';
import { routePathByObjId } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import { performanceNodeTabs } from '@/constants/performance';

export default {
  name: 'WStorageClusterPerfTable',
  components: {
    WRscPerfEventProgressBar,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    const logicalColumns = [
      { label: '스토리지 클러스터 명', prop: 'objName', scopedSlot: 'obj-name-slot', remoteProp: 'o.obj_name', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
      { label: '가상화센터 명', prop: 'virtualcenterName', remoteProp: 'vvc.virtualcenter_name', sortable: true, searchable: true, formatter: this.virtualCenterNameFormatter },
      { label: '전체 용량(Byte)', prop: 'VDSC_STORAGE/TOTAL_CAPACITY', sortable: true, formatter: this.convertValue },
      { label: '사용량(Byte)', prop: 'VDSC_STORAGE/USED_CAPACITY', sortable: true, formatter: this.convertValue },
      { label: '사용률(%)', prop: 'VDSC_STORAGE/USERATE', sortable: true, scopedSlot: 'disk-slot', align: 'center' },
      { label: '가용량(Byte)', prop: 'VDSC_STORAGE/AVSIZE', sortable: true, formatter: this.convertValue },
    ];
    const physicalColumns = [
      { label: '스토리지 클러스터 명', prop: 'objName', remoteProp: 'o.obj_name', scopedSlot: 'obj-name-slot', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
      { label: '전체 용량(Byte)', prop: 'VDSC_STORAGE/TOTAL_CAPACITY', sortable: true, formatter: this.convertValue },
      { label: '사용량(Byte)', prop: 'VDSC_STORAGE/USED_CAPACITY', sortable: true, formatter: this.convertValue },
      { label: '사용률(%)', prop: 'VDSC_STORAGE/USERATE', sortable: true, scopedSlot: 'disk-slot', align: 'center' },
      { label: '가용량(Byte)', prop: 'VDSC_STORAGE/AVSIZE', sortable: true, formatter: this.convertValue },
    ];
    return {
      params: {
        objtypeIds: ['VDSC'],
      },
      isLoading: false,
      tableDatas: [],
      columnDefault,
      tableTotal: 0,
      showSearchTool: false,
      columns: [],
      EMPTY_TEXT,
      logicalColumns,
      physicalColumns,
    };
  },
  computed: {
    ...mapGetters(['selectedNode', 'selectedObjDefineIds']),
    treeType() {
      return this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
    },
  },
  watch: {
    selectedNode: {
      handler() {
        if (this.$refs.storageClusterTable === undefined) {
          this.$nextTick(() => {
            this.$refs.storageClusterTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
            this.loadStore();
          });
        } else {
          this.$refs.storageClusterTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
          this.loadStore();
        }
      },
      immediate: true,
    },
    active: {
      handler() {
        this.loadStore();
      },
    },
  },
  methods: {
    isNil,
    loadStore() {
      if (this.active) {
        this.isLoading = true;
        const tableParams = this.$refs.storageClusterTable.getParameter();
        this.columns = this.logicalColumns;
        if (isEqual(this.treeType, 'logical')) {
          this.params.managegroupIds = this.selectedNode.childManagegroupIds;
        } else {
          this.params.objId = this.selectedNode.obj ? this.selectedNode.obj.objId : null;
          this.params.objtypeId = this.selectedNode.obj ? this.selectedNode.obj.objtypeId : this.selectedNode.objtypeId;
          this.params.virtualcenterGroupId = this.selectedNode.virtualcenterGroupId;
          // this.columns = this.physicalColumns;
        }
        const targetParams = {
          ...tableParams,
          ...this.params,
          treeType: this.treeType,
          subType: this.selectedNode.subType,
          hypervisorType: this.selectedNode.hypervisorType,
        };
        VmsPerfCommonAPI.getPerformanceCommonListview(targetParams).then((response) => {
          if (response.data.success) {
            this.tableDatas = response.data.data;
            this.tableTotal = response.data.total;
          }
        }).catch(() => {}).finally(() => {
          this.isLoading = false;
        });
      }
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    getStringtoNumber(value) {
      return Number(value);
    },
    onChangeTable() {
      this.loadStore();
    },
    /**
     * [convertValue VMS - rscinfos에서 key값으로 대상 value의 unit 조회]
     * @author {Song}
     * @return {[type]} [description]
     */
    convertValue(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      const targetKey = split(column.property, '/');
      const targetUnit = row.rscInfos.find((item) => item.rsctypeId === targetKey[0] && item.rscId === targetKey[1]);
      return convertValuByUnit(value, targetUnit.rscUnit);
    },
    // 논리그룹 - 성능/구성 테이블 가상화 센터명 컬럼 formatter
    virtualCenterNameFormatter(row) {
      let result = '';
      if (row.virtualcenterName === '' || isNil(row.virtualcenterName)) {
        result += EMPTY_TEXT;
      } else {
        result += row.virtualcenterName;
      }
      if (row.basicinfoSubname === '' || isNil(row.basicinfoSubname)) {
        result += ` (${EMPTY_TEXT})`;
      } else {
        result += ` (${row.basicinfoSubname})`;
      }
      return result;
    },
    /**
     * 장비명 클릭 시 성능/운영 > 요약 탭으로 이동한다. [애플망고 SK]
     * @author Song
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickObjName(row) {
      if (!isNil(row.objId)) {
        routePathByObjId(this, row.objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds, null, false);
      }
    },
    convertValuByUnit,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/components/virtual/StorageClusterPerfTable.vue